import React, { useEffect } from "react";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

const LeaveByTypeOverviewChart = () => {
  const leaveColors = ["#4875E9", "#9AB3F3"];
  const data = [
    {
      leave: "Paid",
      balance: 12,
    },
    {
      leave: "Unpaid",
      balance: 12,
    },

    {
      leave: "Total Leave",
      balance: 12,
    },
  ];
  useEffect(() => {
    const ctx = document.getElementById("leaveByTypeChart").getContext("2d");
    const myChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: ["", "", "", "", ""],
        datasets: [
          {
            label: "# of Votes",
            data: [77, 23],
            backgroundColor: leaveColors,
          },
        ],
      },
      options: {
        scales: {},
        plugins: {
          legend: {
            display: false,
          },
        },
      },
    });
    return () => {
      myChart.destroy();
    };
  });

  return (
    <>
      <div className="border rounded-md p-3 w-[422px]">
        <div className="flex justify-between">
          <p className="font-medium">Leave By Type</p>
          <p className="flex items-center gap-2">
            This Year
            <i className="ico-down" />
          </p>
        </div>

        <div className="flex items-center py-4">
          <div className="w-[160px] px-3">
            <canvas id="leaveByTypeChart" width="160" height="160"></canvas>
          </div>

          <div className="flex flex-wrap flex-col w-full">
            {data.map((item, index) => {
              return (
                <>
                  <div className="flex pb-3 pr-5" key={index}>
                    <span
                      className={`h-3 w-5 rounded-[20px] bg-[${leaveColors[index]}] mr-3`}
                    ></span>
                    <p>{item.leave}</p>
                    <h3 className="ml-auto text-gray-800 font-medium">
                      {item.balance}
                    </h3>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveByTypeOverviewChart;
